/**
 * Staging build — `ng build --configuration=staging` (or `ng serve --configuration=staging`).
 * Set `apiBaseUrl` to your deployed API origin + global prefix (e.g. `https://api-staging.yourdomain.com/api/v1`).
 * Session cookies require a real API origin, not a path-only dev proxy.
 */
export const environment = {
  production: true,
  envName: 'staging' as const,
  /** Base URL including `/api/v1` (no trailing slash). */
  apiBaseUrl: 'https://apduatsuperadminapi.katdev.com/api/v1',
  wsBaseUrl: 'https://apduatsuperadminapi.katdev.com',
  enablePermissionChecks: true,
  bypassAllPermissions: false,
};
